import { brochure } from "../data/scenes";

export default function BrochureViewer() {
    return (
        <div
            style={{
                width: "100%",
                height: "100vh",
                background: "#000",
            }}
        >
            <iframe
                src={brochure}
                title="Brochure"
                width="100%"
                height="100%"
                style={{
                    border: "none",
                }}
            />
        </div>
    );
}